import React, {useRef} from "react";
import AttachmentFileList from "./AttachmentFileList";
import AttachmentListUploader from "./AttachmentListUploader";
import {AttachmentContainer, AttachmentLane} from "./AttachmentContainer";
import {appendDocFiles} from "./createAttachHelpers";
import {getVisibleDocs, removeAttachItem} from "./editAttachState";

export default function EditAttachPanel({attachState, setAttachState}) {
    const docIdRef = useRef(0);

    const handleDocInput = (e) => {
        setAttachState((prev) => ({
            ...prev,
            pendingDocs: appendDocFiles(prev.pendingDocs, e.target.files, docIdRef),
        }));
        e.target.value = "";
    };

    const visibleDocs = getVisibleDocs(attachState);
    const listItems = visibleDocs.map((item) => ({
        id: item.id,
        originalName: item.originalName || item.object?.name || item.uploadName || "파일",
        object: item.object,
    }));

    return (
        <AttachmentContainer>
            <AttachmentLane label="파일" variant="file" count={listItems.length}>
                <AttachmentListUploader
                    inputId="edit_asset_doc"
                    onInputChange={handleDocInput}
                    hasFiles={listItems.length > 0}
                    fileList={
                        <AttachmentFileList
                            items={listItems}
                            onRemove={(item) => removeAttachItem(setAttachState, item, "doc")}
                        />
                    }
                />
            </AttachmentLane>
        </AttachmentContainer>
    );
}
